export default "__VITE_ASSET__DIa_$_7X__"